import { useState } from "react";

import { pinDe } from "../../services/choferCruce";

/* El PIN de la tarjeta YPF, tapado hasta que alguien lo pida.
 *
 * ── POR QUÉ NO VIENE CON EL RESTO DE LA FICHA ────────────────────────────
 *
 * Es una CREDENCIAL DE PAGO. `chofer_pin` es tabla aparte y con su propia RLS
 * (`ver.pin_ypf`) exactamente por esto: para que la consulta de documentación
 * —la que hace todo el mundo— no lo traiga de arriba sin que nadie lo pida.
 *
 * Traerlo junto con la ficha lo dejaría en la memoria del navegador de cada
 * persona que abre una ficha, y en cualquier captura de pantalla de esa
 * pantalla. El permiso seguiría estando y no serviría de nada.
 *
 * ── LA RLS FILTRA EN SILENCIO, Y POR ESO EL «NO» ES AMBIGUO ─────────────
 *
 * Sin el permiso, la consulta no falla: devuelve vacío, igual que si la
 * persona no tuviera PIN cargado. No hay forma de distinguirlos desde acá, así
 * que el mensaje dice las dos posibilidades en vez de afirmar la que no se
 * puede probar. Decir «no tiene PIN» a alguien que sí lo tiene manda a
 * cargarlo de nuevo.
 */
const Pin = ({ dni }) => {
  const [pin, setPin] = useState(null);      // null = todavía tapado
  const [error, setError] = useState("");
  const [yendo, setYendo] = useState(false);

  const destapar = async () => {
    setYendo(true);
    setError("");
    const r = await pinDe(dni);
    setYendo(false);
    if (r.error) {
      setError(r.error);
      return;
    }
    setPin(r.pin);
  };

  if (pin) {
    return <p className="mono pf-pin">{pin}</p>;
  }

  return (
    <>
      <p className="tenue">Tiene PIN cargado.</p>
      <button
        type="button"
        className="btn-suave"
        onClick={destapar}
        disabled={yendo}
      >
        {yendo ? "Buscando…" : "Ver el PIN"}
      </button>
      {error && <p className="pf-nopude">{error}</p>}
    </>
  );
};

export default Pin;
